const detectFbIab = () => {
  return Boolean(navigator.userAgent.match(/FBAN|FBAV/i));
};
const detectLineIab = () => {
  return Boolean(navigator.userAgent.match(/Line\/[\d.]+\/IAB/i));
};
const detectIosDevice = () => {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
};
export {
  detectFbIab,
  detectIosDevice,
  detectLineIab
};
